import clsx from "clsx";

export default function SaveButtons({
  onSaveStayClick,
  useSaveExitClick,
  onExitClick,
  missingField,
  errorMsg,
  confirmMsg,
}) {
  return (
    <>
      <div className="h-[20px] mt-4">
        {missingField && (
          <div className="text-red">
            You must add a title, date, and URI in order to save.
          </div>
        )}
        {confirmMsg && (
          <div className="text-[green]">Your article has been saved!</div>
        )}
        {errorMsg && <div className="text-red">{errorMsg}</div>}
      </div>
      <div className="w-full flex justify-between">
        <button className={goBackBtn} onClick={onExitClick}>
          go back
        </button>
        <button className={submitBtn} onClick={onSaveStayClick}>
          save & keep editing
        </button>
        <button className={exitBtn} onClick={useSaveExitClick}>
          save & go back
        </button>
      </div>
    </>
  );
}

const btnStyle = clsx(
  "h-10 w-1/2 mr-4 last:mr-0 uppercase px-2 font-bold text-xs tracking-wider rounded-md mb-10 hover:scale-[101%]"
);
const goBackBtn = clsx(btnStyle + " bg-red ");
const exitBtn = clsx(btnStyle + " bg-green ");
const submitBtn = clsx(btnStyle + " bg-black  text-white ");
